import React,{useEffect,useState} from 'react' 
import Search from'../Component/Search' 
import '../Assets/css/menu.css'
import {useLocation,Link ,NavLink} from 'react-router-dom'
const Header = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
      }, [pathname]);
    const [isOpen, setIsOpen] = useState(); 
    const toggleMenu = () => {
        setIsOpen(!isOpen);
    }; 

  return (
      <>
        <div className="header">
        <div className="row">
        <div className="col-lg-3 col-12">
          <div className="midheaderleft">
              <Link to="/"><img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/logo.png" className="img-fluid" /></Link>
          </div>
            </div>
            <div className="col-lg-9"> 
                  <div className="headermid">
                  <div className="topheaderli">
                      <ul>
                          <li><Link to="/Admission">Admission </Link></li>
                          <li><Link to="/">exam</Link></li>
                          <li><Link to="/">tender</Link></li>
                          <li><Link to="/Cbse">cbse disclosure</Link></li>  
                      </ul>
                    </div> 
                    <div class="search">
                      <Search/> 
                  </div>  
                  <a href="https://entab.online/SJCQPB"  target="_blank"><button type="button" className="erpbtn">ERP LOGIN</button> </a>
                   <div className="menubtn" onClick={toggleMenu}>
                      <div className='img'> <img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/menu.png" /></div>
                   </div>
                  </div>
            </div> 
        </div> 
        
        {isOpen && (
            <div>
                <div className="back-overlay" onClick={toggleMenu}></div>
                <div className='crossMe' onClick={toggleMenu}>
                <i class="bi bi-x-circle-fill"></i>
                </div>
                <div className="menu">
                <div className="logo">
                    <NavLink to="/"><img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/logo.png" className="img-fluid" /></NavLink>
                </div>
                <ul className="submenu">

                    <li>About Us
                        <ul className="sub-submenu">
                            <li><NavLink to='/AboutUs'>About Us</NavLink></li> 
                            <li><NavLink to='/VissionMission'>Vission  & Mission</NavLink></li> 
                        </ul>
                    </li>
                    <li>Academic
                        <ul className="sub-submenu">
                            <li><NavLink to='/ExaminationPromotion'>Examination & Promotion</NavLink></li> 
                            <li><NavLink to='/Fee'>Fee</NavLink></li> 
                            <li><NavLink to='/WithdrawalsDismissals'>Withdrawals & Dismissals</NavLink></li> 
                            <li><NavLink to='/SchoolUniform'>  Uniform</NavLink></li>  
                        </ul>
                    </li>
                    <li>Facilities
                        <ul className="sub-submenu">
                            <li><NavLink to='/Facilities'>Facilities</NavLink></li>  
                        </ul>
                    </li>
                    <li>Admission
                        <ul className="sub-submenu">
                             <li><NavLink to='/Admission'>Admission</NavLink></li> 
                             <li><NavLink to='/AdmissionRequirements'>Admission Requirements</NavLink></li> 
                             <li><NavLink to='/Registration'>Registration</NavLink></li> 
                        </ul>
                    </li>
                    <li>Gallery
                    <ul className="sub-submenu">
                         <li><NavLink to='/Gallery'>Gallery</NavLink></li> 
                         <li><NavLink to='/VideoGallery'> Video Gallery</NavLink></li>  
                    </ul>
                </li>
                <li>Contact Us
                    <ul className="sub-submenu">
                        <li><NavLink to='/ContactUs'>Contact Us</NavLink></li>   
                    </ul>
                </li>
                </ul>
            </div>
        </div> 
    
        )}
        </div>
      </>
           
  )
}

export default Header
